import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipoComponent } from './pages/equipo/equipo.component';
import { SharedModule } from '../../shared/shared.module';
import { TeamMemberBlockComponent } from './components/team-member-block/team-member-block.component';
import { EquipoPersonaComponent } from './pages/equipo-persona/equipo-persona.component';
import { RouterModule } from '@angular/router';
import { JobsComponent } from './pages/jobs/jobs.component';



@NgModule({
  declarations: [
    EquipoComponent,
    TeamMemberBlockComponent,
    EquipoPersonaComponent,
    JobsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ]
})
export class EquipoModule { }
